import React from 'react';
import error from '../../error.gif'
const NotFound = () => {
    return (
        <div>
             <>
             
             <div className='not'>
          
          <img className="mt-10 h-50 w-full"src={error} alt=''/>
       </div>
       </>
        </div>
    );
};

export default NotFound;